import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import ApplicationSerializer from 'lumen/serializers/application';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class TransactionMappingHierarchyCategorySerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    subCategories: { embedded: 'always' },
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey() {
    return 'transaction-mapping/hierarchy-category';
  }
}
